export default __webpack_public_path__ + "static/media/logo-main.5983d29e.png";